<template>
  <CRow>
    <CCol sm="12">
      <CCard>
        <CCardHeader class="d-flex justify-content-between align-items-center">
          <div>آزمون آنلاین</div>
          <CButton
              :disabled="loading"
              class="px-lg-5 py-lg-2"
              color="primary"
              @click="addExamModal = true"
          >
            <CIcon name="cil-plus"/>
            افزودن
          </CButton>
        </CCardHeader>
        <AddExamModal v-model="addExamModal" @get-exams="getExams"/>
        <CCardBody class="d-flex align-items-center text-center h-100">
          <CDataTable
              :fields="fields"
              :items="computedExams"
              :loading="loading"
              :noItemsView="{
              noItems: 'در حال حاضر محتوایی در این قسمت وجود ندارد',
            }"
              border
              class="w-100 d-flex justify-content-between h-100"
              column-filter
              fixed
              hover
              small
              striped
          >
            <template #status="{ item }">
              <td>
                <CBadge :color="getBadge(item.status)">
                  <div v-if="item.status === 'BEFORE'">فرا نرسیده</div>
                  <div v-if="item.status === 'FINISHED'">به پایان رسیده</div>
                  <div v-if="item.status === 'ACTIVE'">مشاهده</div>
                </CBadge>
              </td>
            </template>

            <template #removeExam="{ item }">
              <td>
                <CButton v-if="item.status !== 'ACTIVE'" size="sm" square @click="onExamViewModal(item)">
                  <CIcon name="cil-trash"/>
                </CButton>
              </td>
            </template>
            <template #addSurvey="{ item }">
              <td>
                <CButton
                    :disabled="loading"
                    size="sm"
                    square
                    @click="onAddSolutionModal(item)"
                >
                  <CIcon name="cil-cloud-upload"/>
                </CButton>
              </td>
            </template>
            <template #showExam="{ item }">
              <td>
                <router-link :to="`/manager/exam/${item.id}`">
                  <CButton
                      :disabled="loading"
                      class="modal-button"
                      size="sm"
                      square
                  >
                    مشاهده
                  </CButton>
                </router-link>
                <router-view @go-to="goTo"></router-view>
              </td>
            </template>

            <template #title-filter><span></span></template>
            <template #examType-filter><span></span></template>
            <template #examTime-filter><span></span></template>
            <template #status-filter><span></span></template>
            <template #removeExam-filter><span></span></template>
            <template #addSurvey-filter><span></span></template>
            <template #showExam-filter><span></span></template>
          </CDataTable>
          <AddSolutionModal
              v-model="addSolutionModal"
              :exam="selectedItem"
              @get-exams="getExams"
          />
          <RemoveExamModal
              v-model="examRemoveModal"
              :exam="selectedItem"
              @get-exams="getExams"
          />
        </CCardBody>
      </CCard>
    </CCol>
  </CRow>
</template>

<script>
import axios from "@/plugins/axios";
import AddExamModal from "@/components/Modals/Exam/AddExamModal.vue";
import AddSolutionModal from "@/components/Modals/Exam/AddSolutionModal.vue";
import RemoveExamModal from "@/components/Modals/Exam/RemoveExamModal.vue";

export default {
  components: {AddExamModal, AddSolutionModal, RemoveExamModal},
  name: "onlineExams",
  data() {
    return {
      loading: false,
      exams: [],
      fields: [
        {key: "title", label: "عنوان"},
        {key: "examType", label: "نوع"},
        {key: "courseName", label: "درس"},
        {key: "computedStartDate", label: "تاریخ"},
        {key: "examTime", label: "ساعت"},
        {key: "status", label: "وضعیت"},
        {key: "removeExam", label: "حذف"},
        {key: "addSurvey", label: "افزودن پاسخنامه"},
        {key: "showExam", label: "مشاهده"},
      ],
      addExamModal: false,
      addSolutionModal: false,
      selectedItem: {},
      examRemoveModal: false,
    };
  },
  computed: {
    computedExams() {
      return this.exams.map((item) => {
        return {
          ...item,
          courseName: this.getCourseName(item).toString(),
          examType: item.type === "TEXT" ? "تشریحی" : "چندگزینه ای",
          examTime: `${item.startTime} تا ${item.endTime}`.replace(/\s/g, '\u00A0'),
          computedStartDate: item.startDate.split("-").join("/"),
        };
      });
    },
  },
  mounted() {
    this.getExams();
  },
  methods: {
    getCourseName(item) {
      let name = "";
      for (let i = 0; i < item.courses.length; i++) {
        name += `${item.courses[i].name} ${item.courses[i].klass.grade.name} ${item.courses[i].klass.name}`;
        if (i < item.courses.length - 1) {
          name += "، ";
        }
      }
      return name;
    },
    async getExams() {
      try {
        this.loading = true;
        const {data} = await axios.get("/exam");
        this.exams = data;
      } catch (error) {
        console.log("error", error);
      } finally {
        this.loading = false;
      }
    },
    getBadge(status) {
      switch (status) {
        case "BEFORE":
          return "primary";
        case "FINISHED":
          return "gray";
        case "ACTIVE":
          return "success";
      }
    },
    onAddSolutionModal(item) {
      this.selectedItem = item;
      this.addSolutionModal = true;
    },
    onExamViewModal(item) {
      this.selectedItem = item;
      this.examRemoveModal = true;
    },
    goTo(item, routeName) {
      routeName = item.title;
      this.$emit("go-to", routeName);
    },
  },
};
</script>

<style lang="scss" scoped>
.badge {
  width: 70px;
  line-height: 2;

  &-primary {
    color: #fff;
  }

  &-success {
    color: #fff;
  }

  &-gray {
    color: #4f5d73;
    background-color: #ced2d8;
  }
}
</style>